const CR_LINE_END = "\r\n";
const C_LINE_END = "\r";
const R_LINE_END = "\n";

//TODO: rethink this linecount approach, didnt work well
export const getLineEnding = (code : string) : string => {
  if (!code || code.length <= 0) {
    return R_LINE_END;
  }
  const hasCR = code.indexOf(CR_LINE_END);
  const hasC = code.indexOf(C_LINE_END);
  const hasR = code.indexOf(C_LINE_END);

  if (hasCR > -1 && (hasCR < hasR || hasCR < hasC)) {
    return CR_LINE_END;
  } else if (hasC > -1 && (hasC < hasCR || hasC < hasR)) {
    return C_LINE_END;
  }
  return R_LINE_END;
}

export const getLinesOfCode = (code : string) : number => {
  if (!code || code.length <= 0) {
    return 0;
  }

  const hasCR = code.indexOf(CR_LINE_END);
  const hasC = code.indexOf(C_LINE_END);
  const hasR = code.indexOf(C_LINE_END);

  if (hasCR > -1 && (hasCR < hasR || hasCR < hasC)) {
    return (code.match(/\r\n/g) || []).length;
  } else if (hasC > -1 && (hasC < hasCR || hasC < hasR)) {
    return (code.match(/\r/g) || []).length;
  }
  return (code.match(/\n/g) || []).length;
}

export const codeAsStringArray = (code : string) : string[] => {
  if (!code || code.length <= 0) {
    return [];
  }
  const hasCR = code.indexOf(CR_LINE_END);
  const hasC = code.indexOf(C_LINE_END);
  const hasR = code.indexOf(C_LINE_END);

  if (hasCR > -1 && (hasCR < hasR || hasCR < hasC)) {
    return code.split(CR_LINE_END);
  } else if (hasC > -1 && (hasC < hasCR || hasC < hasR)) {
    return code.split(C_LINE_END);
  }
  return code.split(R_LINE_END);
}

export const getCodeAtLine = (line : number, code : string) : string => {
  const hasCR = code.indexOf(CR_LINE_END);
  const hasC = code.indexOf(C_LINE_END);
  const hasR = code.indexOf(C_LINE_END);
  let lines = code.split(R_LINE_END);
  if (hasCR > -1 && (hasCR < hasR || hasCR < hasC)) {
    lines = code.split(CR_LINE_END);
  } else if (hasC > -1 && (hasC < hasCR || hasC < hasR)) {
    lines = code.split(C_LINE_END);
  }
  console.log('found lines', lines)
  return lines[line - 1];
}

export const getLineIndexInCode = (codeLine : string, code : string) : number => {
  const locs = codeAsStringArray(code);
  const lineIndex = locs.findIndex((line) => line.indexOf(codeLine) > -1);
  return lineIndex >= 0 ? lineIndex : -1;
}

export const getEditorLineNumberFromError = (executionCode : string, errorLine : number, editorCode : string) => {
  const scriptStartKeyword = "/*PROJECT_CODE_START*/"
  const scriptStartLineIndex = getLineIndexInCode(scriptStartKeyword, executionCode);
  const codeAtLine = getCodeAtLine(scriptStartLineIndex + errorLine, executionCode);

  const lineInEditorCode = getLineIndexInCode(codeAtLine, editorCode) + 1;
  console.log('searching code at line: ' + errorLine, codeAtLine, lineInEditorCode)
  return lineInEditorCode;
}

export const removeLineBreaks = (line: string) => {
  if (!line) return "";
  return line.replace(/\r\n/g, "").replace(/\r/g, "").replace(/\n/g, "");
}
